<div *ngIf="!isViewResult">
  <label>{{idx+1}}. {{ question.content }}</label>
  <div *ngFor="let radio of question.options; let i = index" class="form-check">
    <input class="form-check-input"
           type="checkbox"
           name="radio{{idx}}"
           [checked]="valueRadio.indexOf(radio.id) != -1"
           [disabled]="statistic"
           (change)="getOptionRadio(i);">
    <label class="form-check-label pl-2">
      {{radio.content}}        ({{radio.count}})
    </label>
  </div>
  <p>{{'controlPanel.criteria.five.radioText' | translate}}</p>
  <p><span>{{numberApp || numberApp == 0 ? numberApp : totalApp}}</span> {{'controlPanel.criteria.applicants' | translate}}</p>
  <div class="form-inline" *ngIf="!statistic">
    <span>{{'controlPanel.criteria.assign' | translate}}</span>
    <input type="number"
           name="score"
           class="form-control mx-2"
           min="0"
           max="99"
           [disabled]="statistic"
           [(ngModel)]="score">
  </div>
  <div style="margin-top: 10px;">
    <button class="btn btn-success" *ngIf="!statistic" (click)="onGetAllResult()">{{'common.update' | translate}}</button>
  </div>
</div>
<div *ngIf="isViewResult">
  <label class="item">{{idx+1}}. {{ question.content }}</label>
  <table class="table table-bordered">
    <thead>
    <tr>
      <th scope="col"><b>{{ 'controlPanel.checkboxQuestion.answer' | translate }}</b></th>
      <th scope="col"><b>{{ 'controlPanel.checkboxQuestion.numOfApplicantsChecking' | translate }}	</b></th>
      <th scope="col"><b>{{ 'controlPanel.checkboxQuestion.answerSelected' | translate }}</b></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let radio of question.options">
      <td>{{radio.content}}</td>
      <td>{{radio.count}}</td>
      <td>{{valueRadio.indexOf(radio.id) != -1 ? 'Yes': 'No'}}</td>
    </tr>
    </tbody>
  </table>
  <p>{{ 'controlPanel.radioQuestion.introSelectAnswer' | translate }}.</p>
  <p><span>{{applicantsFulfill}}</span> {{'controlPanel.applicantFulfilled' | translate }} <b>{{score}}</b></p>
</div>
<hr>
